// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"9d10f2db","732":"8c8c43ca","977":"4853077b"}[chunkId] + ".chunk.js";
};